import { createFileRoute, redirect } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { getRouteHead } from '~/utils/routeUtils';

import { Settings } from '~/components/settings/Settings';

import { MASTERDATA } from './masterdata';

const title = i18n.t(($) => $.settings.pageTitle, { ns: 'common' });

export const Route = createFileRoute('/(main)/settings')({
  component: Settings,
  head: () => getRouteHead(title),
  loader(ctx) {
    if (ctx.location.pathname === Route.fullPath) {
      redirect({ to: MASTERDATA.Route.to, throw: true });
    }
  },
  staticData: {
    AppBar: {
      title,
    },
  },
});
